import React from 'react';
import {withAppContext} from './AppContext';
import * as plural from 'plural-ru';

const WordCount = ({words}) =>
  <div className="wordcount">{ words || 0 } { plural(words, 'слово', 'слова', 'слов') }</div>

export default withAppContext(WordCount);
